import { Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { ApiService, IChatAttachment } from '@cakeiteasy/web-utils';

@Injectable()
export class ChatImageUploadService {
  constructor(private _api: ApiService) {
  }

  public uploadImage(image: string): Promise<IChatAttachment> {
    return firstValueFrom(this._api.post('api.extra', 'images', null, {
      image,
      fileName: `${Math.floor(Math.random() * 100)}-${Date.now()}.jpg`
    }));
  }
}
